import { Button, Container, Stack } from '@mantine/core';
import { FileBadge2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageHeader from '@components/shared/PageHeader';
import { AdminCoursesTable } from './components/AdminCoursesTable';

export default function AdminCourses() {
  return (
    <Container size='2xl' py='lg'>
      <Stack gap='lg'>
        <PageHeader
          title='Courses'
          breadcrumbs={[
            { label: 'Admin', href: '/admin' },
            { label: 'Courses' },
          ]}
          showBackButton={false}
          actions={
            <Button
              component={Link}
              to='/admin/courses/certificate-templates'
              variant='light'
              leftSection={<FileBadge2 size={18} />}
            >
              Visualizza templates
            </Button>
          }
        />

        <AdminCoursesTable />
      </Stack>
    </Container>
  );
}
